import { imageUrl, imageSrcSet } from '../api';

// UPLOAD_Images_to_GCS.md ("faster images") - a responsive <img> for listing photos. Uploaded
// photos ship as a WebP ladder (see routes/uploads.js); this renders `srcSet` + `sizes` so a
// mobile / slow-network visitor downloads a 320-640px file instead of the multi-MB original,
// plus `loading="lazy"` + `decoding="async"` so off-screen cards don't block the first paint.
// Pass `eager` for the one above-the-fold image on a page (first card / detail hero).
// Legacy single-URL images (plain .jpg/.png) degrade to a plain <img src>.
export default function ListingImage({
  src, alt = '', sizes = '(max-width: 768px) 100vw, 33vw',
  eager = false, className, style, onClick, ...rest
}) {
  const url = imageUrl(src);
  const srcSet = imageSrcSet(src);
  return (
    <img
      src={url}
      srcSet={srcSet || undefined}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      // React 18.3+/19 recognizes fetchPriority as a first-class camelCase prop - the lowercase
      // spelling now trips "Invalid DOM property" dev warnings instead of passing through.
      fetchPriority={eager ? 'high' : undefined}
      className={className}
      style={style}
      onClick={onClick}
      {...rest}
    />
  );
}
